// TODO: Moment is deprecated. Migrate to https://moment.github.io/luxon/
import moment from 'moment-timezone';
import uploadWidgetPlugin from './uploadWidgetPlugin';

function initialiseFormWidgets() {    
    if (document.querySelector('.file-upload-tool, .image-upload-tool')) {
        enable_upload_widget();
    }
    if (document.querySelector('input[data-widget="google-font-select"]')) {
        var myScript = document.createElement('script');
        myScript.type = 'text/javascript';
        myScript.src = '/static/frontend/js/form-widgets/google-font-field.js';
        document.head.appendChild(myScript);
    }
}

/****** File upload form field widget ******/

function enable_upload_widget(){
    var uploadElements = [...document.querySelectorAll('.file-upload-tool, .image-upload-tool')];
    uploadElements.forEach(function(el){
       new uploadWidgetPlugin(el);
    });
}
/****** Date and time form field widget ******/
var monthNames = ["January", "February", "March", "April", "May", "June",
"July", "August", "September", "October", "November", "December"
];
function generateElement(html) {
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    return template.content.firstChild;
}
function createDatePicker(el){    
    el.style.display = 'none';
    var wrapper = generateElement("<div class='date-picker-wrapper'><select class='day input-xlarge form-control'><option value=''>-D-</option></select><select class='month input-xlarge form-control'><option value=''>-M-</option></select><select class='year input-xlarge form-control'><option value=''>-Y-</option></select></div>");
    el.insertAdjacentElement('afterend', wrapper);
    var dayEl = wrapper.querySelector('.day');
    var monthEl = wrapper.querySelector('.month');
    var yearEl = wrapper.querySelector('.year');

    if (!el.classList.contains('time')){
        for (let i=1; i < 32;i++){
            dayEl.insertAdjacentHTML('beforeEnd', '<option value="' +i+'">' +i+'</option>');
        }
        for (let i=0; i < 12;i++){
            monthEl.insertAdjacentHTML('beforeEnd', '<option value="' +i+'">' +monthNames[i]+'</option>');
        }
        var year = new Date().getFullYear();
        let opt = generateElement('<option>... older ...</option>');
        yearEl.insertAdjacentElement('beforeEnd', opt);
        yearEl.dataset.start = year - 1;
        yearEl.addEventListener('change', function(){
            if (yearEl.options[yearEl.selectedIndex] == opt) {
                year=0;
                for (year=yearEl.dataset.start-1; year > yearEl.dataset.start - 11;year--){
                    opt.insertAdjacentHTML('afterEnd', `<option value="${year}">${year}</option>`)
                }
                yearEl.dataset.start = year+1;
                yearEl.value = null;
            }
        })
        for (let i=-1; i < 10;i++){
            yearEl.insertAdjacentHTML('beforeEnd', '<option value="' +(year+i)+'">' +(year+i)+'</option>');
        }
    } else {
        dayEl.remove();
        monthEl.remove();
        yearEl.remove();
    }
    if (el.classList.contains('date-time') || el.classList.contains('time')){
        var hourEl = generateElement("<select class='hour input-xlarge form-control'></select>");
        var minuteEl = generateElement("<select class='minute input-xlarge form-control'></select>");
        if (!el.classList.contains('time'))
            wrapper.insertAdjacentHTML('beforeEnd', "<span class='divider'>&nbsp;</span>");
        wrapper.insertAdjacentElement('beforeEnd', hourEl);
        wrapper.insertAdjacentHTML('beforeEnd', "<span class='divider'>:</span>");
        wrapper.append(minuteEl);
        var i;
        for (i=0; i < 24;i++){
            hourEl.insertAdjacentHTML('beforeEnd', '<option value="' + i.lpad(2) +'">' + i.lpad(2) +'</option>');
        }
        for (i=0; i < 60;i+=5){
            minuteEl.insertAdjacentHTML('beforeEnd', '<option value="' + i.lpad(2) +'">' + i.lpad(2) +'</option>');
        }
    }
    if (!el.classList.contains('time')){
        if (moment(el.value).isValid()) {
            var the_date = moment(el.value);
            var tz_name = Intl.DateTimeFormat().resolvedOptions().timeZone;
            the_date = the_date.tz(tz_name);
            yearEl.value = the_date.year();
            if (yearEl.value != the_date.year()) {
                // Need to append that year.
                yearEl.insertAdjacentHTML('beforeEnd', `<option value="${the_date.year()}" selected>${the_date.year()}</option>`);
            }
            monthEl.value = the_date.month();
            dayEl.value = the_date.date();
            if (el.classList.contains('date-time')){
                hourEl.value = the_date.hour().lpad(2);
                minuteEl.value = the_date.minute().lpad(2);
                if (minuteEl.value != the_date.minute().lpad(2)) {
                    // Need to append that minute.
                    minuteEl.insertAdjacentHTML('beforeEnd', `<option value="${the_date.minute().lpad(2)}" selected>${the_date.minute().lpad(2)}</option>`);
                }
            }
        } else {
            //invalid date... Scrap it.
            el.value = '';
        }
    } else {
        var vals = el.value.split(':');
        if (vals.length == 2) {
            hourEl.value = parseInt(vals[0]).lpad(2);
            minuteEl.value = parseInt(vals[1]).lpad(2);
        } else {
            //invalid time... Scrap it.
            el.value = '';
        }
    }
    function updateDataField(){
        if (yearEl.value != '' && monthEl.value != '' && dayEl.value != '') {
            var tz_name = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (el.classList.contains('date-time')){
                the_date = moment.tz([yearEl.value,monthEl.value, dayEl.value, hourEl.value, minuteEl.value], tz_name)
                the_date = the_date.utc();
                el.value = the_date.toISOString();
                
            } else {
                the_date = moment.tz([yearEl.value, monthEl.value, dayEl.value], tz_name);
                the_date = the_date.utc();
                el.value = the_date.format('YYYY-MM-DD');
            }
        } else if (el.classList.contains('time')) {
            el.value = hourEl.value+':'+minuteEl.value;
        } else {
            el.value = '';
        }
        // Dispatch a change event to the form element
        el.dispatchEvent(new Event('change', { 'bubbles': true }));
    }
    if (!el.classList.contains('time')){
        dayEl.addEventListener('change', updateDataField);
        monthEl.addEventListener('change', updateDataField);
        yearEl.addEventListener('change', updateDataField);
    }
    if (el.classList.contains('date-time') || el.classList.contains('time')){
        hourEl.addEventListener('change', updateDataField);
        minuteEl.addEventListener('change', updateDataField);
    }
}

function initialiseDatePickers() {
    let datePickerElements = [...document.querySelectorAll('.date-picker-tool')];
    datePickerElements.forEach(function(el){ createDatePicker(el)});
}


Number.prototype.lpad = function(length) {
    var str = this.toString();
    while (str.length < length)
        str = "0" + str;
    return str;
}

if (document.querySelector(".image-select-widget")) {
    import(/* webpackChunkName: "image_select_widget" */ './widgets/image-choice-widget').then(image_select_widget =>{
        image_select_widget.initialise();
    });
}
let _initialised = false;
export function initialise() {
    if (_initialised) return;
    _initialised = true;
    initialiseFormWidgets();
    initialiseDatePickers();
}
// Check if the DOMContentLoaded event has already occurred
if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // Run the script immediately
    initialise();
} else {
    // Add an event listener for the DOMContentLoaded event
    document.addEventListener('DOMContentLoaded', initialise);
}
